(() => {
  const labelsToRemove = new Set(['edit personalization', 'preview']);
  const cartRootSelector = 'cart-items, cart-drawer, cart-notification';
  const protectedContainerSelector =
    '.cart-item__details, .cart-item, cart-items, cart-drawer, cart-notification, form, table, tbody, tr, td, dl';

  const normalize = (value) =>
    String(value ?? '')
      .replace(/[\u200B-\u200D\u2060\uFEFF]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .replace(/[:：]$/, '')
      .toLowerCase();

  const removeEmptyParents = (element) => {
    let current = element;
    let depth = 0;

    while (current && depth < 3 && !current.matches(protectedContainerSelector)) {
      const parent = current.parentElement;
      const hasText = normalize(current.textContent) !== '';
      const hasContent = current.querySelector(
        'a, button, input, select, textarea, img, picture, svg, canvas, video, iframe, [role="button"]'
      );

      if (hasText || hasContent) break;
      current.remove();
      current = parent;
      depth += 1;
    }
  };

  const removeControls = (scope = document) => {
    if (scope.nodeType === Node.TEXT_NODE) scope = scope.parentElement;
    if (!scope || !scope.querySelectorAll) return;

    const elements = Array.from(scope.querySelectorAll('*'));
    if (scope.nodeType === Node.ELEMENT_NODE) elements.unshift(scope);

    elements.forEach((element) => {
      if (!element.isConnected || !element.closest(cartRootSelector)) return;
      if (element.closest('script, style, template, noscript')) return;

      const text = normalize(element.textContent);
      const value = 'value' in element ? normalize(element.value) : '';
      if (!labelsToRemove.has(text) && !labelsToRemove.has(value)) {
        const matchingTextNodes = Array.from(element.childNodes).filter(
          (node) => node.nodeType === Node.TEXT_NODE && labelsToRemove.has(normalize(node.nodeValue))
        );

        if (matchingTextNodes.length === 0) return;
        matchingTextNodes.forEach((node) => node.remove());
        removeEmptyParents(element);
        return;
      }

      const hasMatchingChild = Array.from(element.children).some((child) =>
        labelsToRemove.has(normalize(child.textContent))
      );
      if (hasMatchingChild) return;

      const target = element.closest('a, button, [role="button"]') || element;
      const parent = target.parentElement;
      target.remove();
      removeEmptyParents(parent);
    });
  };

  if (window.fusedCustomilyCartControlsObserver) {
    removeControls();
    return;
  }

  const start = () => {
    removeControls();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          removeControls(mutation.target.parentElement);
          return;
        }

        mutation.addedNodes.forEach((node) => removeControls(node));
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    window.fusedCustomilyCartControlsObserver = observer;
  };

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
